export function wxtoken(data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/user/v1/check/wx-token',
    data
  })
}
// export function ticket (params) {
//   return this.fetch({
//     method: 'GET',
//     url: 'wx-server/util/js/api/ticket',
//     params
//   })
// }

// 获取关注二维码
// export function getQrCode (params) {
//   return this.fetch({
//     method: 'GET',
//     url: 'mini-program-server/api/util/v1/follow/qrCode',
//     params
//   })
// }
